import { useController } from "react-hook-form";

export function Checkbox(props) {
  const { label, name, control } = props;
  const { field } = useController({
    name,
    control,
  });

  return (
    <div className="relative flex items-start">
      <div className="flex h-6 items-center">
        <input
          id={field.name}
          aria-describedby="comments-description"
          name={field.name}
          type="checkbox"
          className="h-4 w-4 rounded border-gray-300 text-blue focus:ring-blue"
          onChange={field.onChange}
          checked={field.value}
        />
      </div>
      <div className="ml-3 font-light text-gray-900 text-xs leading-6">
        <label htmlFor={name} className="">
          {label}
        </label>{" "}
      </div>
    </div>
  );
}
